import React, { useEffect, useMemo, useState } from 'react';
import useTonConnect from '../hooks/useTonConnect';
import { ConnectResult } from '../TomoContext';

/**
 * useTonConnect hook --> TonConnect component
 * just for lazy load
 */
interface IProps {
  closeModal: () => void;
  setProviders: (providers: Record<string, any>) => void;
  setConnectResult?: (result: ConnectResult) => void;
  updateTonConnect: (obj: {
    connect: (connectParams?: { tonProof?: string }) => Promise<string>;
    connected: boolean;
  }) => void;
}

const TonConnect = ({
  closeModal,
  setProviders,
  setConnectResult,
  updateTonConnect,
}: IProps) => {
  const { connect, connected } = useTonConnect({
    connectSuccess: closeModal,
    setProviders,
    setConnectResult,
  });

  useEffect(() => {
    updateTonConnect({ connect, connected });
  }, [connect, connected]);

  // lazy load and connect immediately
  useEffect(() => {
    connect();
  }, []);

  return <></>;
};

export default TonConnect;
